import util from "@/helpers/util";

export class DealDetails {
    dealId: number = 0;
    dealID?: number; // Backend sends dealID (acronym kept uppercase), map to dealId
    title: string = '';
    description: string = '';
    imgUrl: string = '';
    retailPrice?: number;
    dealPrice?: number;
    dealUrl: string = '';
    dealURL?: string; // Backend sends dealURL (acronym kept uppercase), map to dealUrl
    dealShortUrl: string = '';
    dealShortURL?: string; // Backend sends dealShortURL (acronym kept uppercase), map to dealShortUrl
    dealProvider: string = '';
    isActive: boolean = false;
    isArchived: boolean = false;
    insertDate?: Date;
    updateDate?: Date;
    productId: string = '';
    productID?: string; // Backend sends productID (acronym kept uppercase), map to productId
    tag: string = '';
    isExpired: boolean = false;
    promoCode: string = '';
    isSoldOut?: boolean;
    prettyTitle: string = '';
    prettyDesc: string = '';
    percentOff: number | null = null;
    isNew?: boolean | null; // Only included if true
    isPriceChanged?: boolean | null; // Only included if true
    searchQuery?: string; // Amazon search query for gift list items

    //FRONT END ONLY
    expirationMessage?: string;
    adType?: string;
    adContent?: string;

    constructor(partial?: Partial<DealDetails>) {
        Object.assign(this, partial);
        
        // Handle property mapping from backend format (with uppercase acronyms) to frontend format
        // Check the raw partial object first in case Object.assign didn't copy it
        const raw = partial as any;
        
        // Map dealID (from backend camelCase with uppercase acronym) to dealId (frontend convention)
        if (raw?.dealID !== undefined && raw?.dealID !== null) {
            this.dealId = raw.dealID;
        } else if (this.dealID !== undefined && this.dealID !== null) {
            this.dealId = this.dealID;
        }
        
        // Map productID (from backend camelCase with uppercase acronym) to productId (frontend convention)
        if (raw?.productID !== undefined && raw?.productID !== null && raw?.productID !== '') {
            this.productId = raw.productID;
        } else if (this.productID !== undefined && this.productID !== null && this.productID !== '') {
            this.productId = this.productID;
        }
        
        // Map dealURL (from backend camelCase with uppercase acronym) to dealUrl (frontend convention)
        // Only map if dealUrl is not already set (to preserve modifications)
        if ((!this.dealUrl || this.dealUrl === '') && raw?.dealURL !== undefined && raw?.dealURL !== null && raw?.dealURL !== '') {
            this.dealUrl = raw.dealURL;
        } else if ((!this.dealUrl || this.dealUrl === '') && this.dealURL !== undefined && this.dealURL !== null && this.dealURL !== '') {
            this.dealUrl = this.dealURL;
        }
        
        // Map dealShortURL (from backend camelCase with uppercase acronym) to dealShortUrl (frontend convention)
        if (raw?.dealShortURL !== undefined && raw?.dealShortURL !== null && raw?.dealShortURL !== '') {
            this.dealShortUrl = raw.dealShortURL;
        } else if (this.dealShortURL !== undefined && this.dealShortURL !== null && this.dealShortURL !== '') {
            this.dealShortUrl = this.dealShortURL;
        }
    }

    hasPrice(): boolean {
        return util.hasValue(this.dealPrice) && this.dealPrice > -0.01
    }
}